function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOaLogoSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 286 174",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.01021,0.0786892,-0.0566808,0.727665,-241.958,-278.905)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M506.884,397.879C531.748,412.548 547.167,432.964 547.167,455.525C547.167,500.181 486.755,536.437 412.343,536.437C368.389,536.437 329.318,523.786 304.705,504.217C328.787,517.485 360.877,525.578 396.092,525.578C470.748,525.578 531.359,489.204 531.359,444.401C531.359,427.089 522.309,411.035 506.884,397.879Z",
    style: {
      fill: "rgb(38,53,133)",
      stroke: "rgb(38,53,133)",
      strokeWidth: "1.13px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-356.799,-413.513)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Good",
    transform: "matrix(1.01186,0.185096,-0.130102,0.711227,135.666,71.9475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M318.888,397.258C303.761,412.762 295.32,430.556 296.112,448.82C298.246,497.982 366.487,532.051 448.406,524.854C470.491,522.914 491.33,518.17 509.949,511.286C485.395,526.787 450.732,536.437 412.343,536.437C337.932,536.437 277.519,500.181 277.519,455.525C277.519,432.638 293.387,411.959 318.888,397.258Z",
    style: {
      fill: "rgb(33,110,184)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M585.93,520.794C580.728,521.177 575.388,521.425 569.93,521.533L569.93,449.426L417.021,449.426L417.021,502.604L401.021,493.751L401.021,433.426L585.93,433.426L585.93,520.794Z",
    style: {
      fill: "rgb(33,110,184)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-356.799,-413.513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M467.854,548.079L512.983,553.703L570.065,548.079L585.93,548.079L598.506,586.667L388.446,586.667L401.021,548.079L467.854,548.079Z",
    style: {
      fill: "rgb(38,53,133)"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-355.775,-413.513)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,0,0.17027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M489.785,467.499L489.785,482.963C489.785,484.435 490.98,485.629 492.452,485.629C493.924,485.629 495.119,484.435 495.119,482.963L495.119,467.499C495.119,466.028 493.924,464.833 492.452,464.833C490.98,464.833 489.785,466.028 489.785,467.499Z",
    style: {
      fill: "rgb(227,120,35)"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M497.785,471.252C504.432,473.482 509.227,479.765 509.227,487.16C509.227,496.419 501.71,503.936 492.452,503.936C483.193,503.936 475.677,496.419 475.677,487.16C475.677,479.765 480.472,473.482 487.119,471.252L487.119,477.037C483.487,478.955 481.01,482.771 481.01,487.16C481.01,493.475 486.137,498.602 492.452,498.602C498.767,498.602 503.894,493.475 503.894,487.16C503.894,482.771 501.417,478.955 497.785,477.037L497.785,471.252Z",
    style: {
      fill: "rgb(227,120,35)"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOaLogoSimple);
export default __webpack_public_path__ + "static/media/oa-logo-simple.0c88cf1edf22e989b3076686130ad304.svg";
export { ForwardRef as ReactComponent };